import React from 'react'

export default function DropdownButtonLink (props) {
  return <a className="download-button" {...props}>{props.children}</a>
}
